// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3nA7K","sendOtp":"AuthorizeToLogin_sendOtp__3NyfI"};